import {
  ChakraProvider,
  Box,
  VStack,
  Grid,
  extendTheme,
  type ThemeConfig,
} from "@chakra-ui/react";

import Form from "./components/Form";
import Intro from "./components/Intro";
import Success from "./components/Success";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const config: ThemeConfig = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};

const theme = extendTheme({ config });

export const App = () => (
  <ChakraProvider theme={theme}>
    <Box textAlign="center" fontSize="xl">
      <Grid minH="100vh" p={3}>
        <Box />
        <VStack spacing={8}>
          <Router>
            <Routes>
              <Route path="/recruitme" element={<Form />} />
              <Route
                path="/"
                element={
                  <Intro
                    title="Let's make things easier for both of us..."
                    subtitle="Click the button below and enter the details for the job. If the job is a good fit then I'll reach out to you and we can discuss how to move forward and take the next steps!"
                    image="https://source.unsplash.com/B3UFXwcVbc4/800x600"
                    formText="Recruit me"
                    formLink="/recruitme"
                  />
                }
              />
              <Route path="/success" element={<Success />} />
            </Routes>
          </Router>
        </VStack>
      </Grid>
    </Box>
  </ChakraProvider>
);
